export default __webpack_public_path__ + "static/media/warning--logging-vehicles--g1.78031a98.png";